import axios from "axios";
import { useState } from "react";
import styled from "styled-components";
import { toast, ToastContainer } from "react-toastify";
import GreenButton from "../../../ui/GreenButton.js";
import Swal from "sweetalert2";


const FormContainer = styled.form`
  width: 100%;
  background-color: #fff;
  box-shadow: 0px 0px 2px #ccc;
  border-radius: 5px;
  margin: 0 auto; 
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;

  @media (max-width: 768px) {
    flex-direction: column;
  }

`;

const DivGeral = styled.form`
  background-color: #fff;
  padding: 20px 20px;
  flex-direction: row;

`;

const Div = styled.td`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-end;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;
const Div4 = styled.td`
  display:flex;
  margin-top: 50px;
  flex-direction: column;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;
const Div3 = styled.td`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-end;
  border: 1px solid #ccc;
  padding: 10px 0px;
  border-radius: 5px;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const InputArea = styled.div`
  width: auto;
  display: flex;
  flex-direction: column;
  padding: 0px 20px;

  select {
    width: 220px;
    padding: 0 10px;
    border: 1px solid #ccc;
    border-radius: 1px;
    height: 37px;
  }
`;

const Input = styled.input`
  width: 200px;
  padding: 0 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  height: 37px;

  
`;

const Label = styled.label`
  color: #575757;
  font-weight: 600;
  font-size: 17px;  
`;





const Div2 = styled.td`
  display: flex;
  flex-direction:column;

`;




const Form = ({ urlApi, fetchUsuarios }) => {


  // tokens
  const token = localStorage.getItem('token');
  const id = localStorage.getItem('id');

  //------------------------------------PESQUISANDO USUÀRIO COM BASE NO CRACHÀ OU LOGIN-------------------------------------------------------------------//

  //Pesquisa os dados do cracha/login no banco de dados
  const [cracha, setCracha] = useState("");
  const [login, setLogin] = useState("");

  //vai receber o res.data do henadleSearch
  const [usuarioEncontrado, setUsuarioEncontrado] = useState(null);

  //Pesquisa os dados do cracha/login no banco de dados
  const handleSearch = async (e) => {
    e.preventDefault();

    const payload = {
      cracha: cracha.trim() || null,
      login: login.trim() || null,
    };

    try {
      const res = await axios.post(`${urlApi}portal/consulta-dados-usuario`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (res.data.length > 0) {
        setUsuarioEncontrado(res.data[0]);
        toast.success("Usuário encontrado!");
      } else {
        setUsuarioEncontrado(null);
        toast.warn("Nenhum usuário encontrado.");
      }
    } catch (error) {
      setUsuarioEncontrado(null);
      toast.error("Nenhum usuário encontrado.");
    }
  };



  //---------------------------------------SALVANDO A SENHA E O EMAIL DO USUARIO----------------------------------------------------------------//


  //popUp que confirma a operação
  const showPopUp = () => {
    return new Promise((resolve) => {
      Swal.fire({
        title: "Deseja confirmar a ação?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        customClass: {
          container: 'custom-swal-container',
        },
      }).then((result) => {
        resolve(result.value); // Resolve a Promise com o valor result.value
      });
    });
  };


  const [senha, setSenha] = useState(null);
  const [repetirSenha, setRepetirSenha] = useState(null);
  const [email, setEmail] = useState("");



  const handleSubmitSenhaEmail = async () => {

    if (senha !== repetirSenha) {
      return toast.error("As senhas não coincidem!");
    }

    if (!email.trim() || !senha.trim() || !repetirSenha.trim()) {
      return toast.error("Por favor, preencha os campos e-mail, senha e repetir senha.");
    }

    const userConfirmed = await showPopUp();
    if (!userConfirmed) return;

    try {
      await axios.post(`${urlApi}portal/novo-usuario/`, {
        cod_funcionario: usuarioEncontrado.COD_FUNCIONARIO,
        logon: usuarioEncontrado.LOGON,
        senha: senha,
        email: email.trim(),
      }, {
        headers: { Authorization: `Bearer ${token}` },
      });

      toast.success("Usuário cadastrado com sucesso!");
      // Salvar log de sucesso no banco de dados
      await logEvento(id, `Adicionou o usuário ${usuarioEncontrado.COD_FUNCIONARIO}-${usuarioEncontrado.LOGON}`);

      fetchUsuarios();
      setSenha('');
      setRepetirSenha('');
      setEmail('');
      setCracha('');
      setLogin('');
      setUsuarioEncontrado('');
    } catch (error) {
      toast.error("Favor verifique, esse usuário já está cadastrado!");
      await logEvento(id, `O usuário ${usuarioEncontrado.COD_FUNCIONARIO}-${usuarioEncontrado.LOGON}, já está cadastrado!`);
    }
  };

  //---------------------------------------SALVANDO LOG DE ALTERACAO---------------------------------------------------------------//

  // Passa o logs para serem salvos no banco
  const logEvento = async (id, descricao) => {
    try {
      const logData = {
        COD_FUNCIONARIO: id,
        DESC_LOG: descricao,
      };

      const response = await fetch(`${urlApi}portal/log`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
        body: JSON.stringify(logData),
      });

      if (!response.ok) {
        throw new Error('Failed to save log');
      }
    } catch (error) {
      console.error('Erro ao salvar log:', error);
    }
  };


  //---------------------------------------------------------------------------------------------------------------------------------//

  return (
    <>
      <FormContainer >
        <DivGeral>
          <Div>
            <Div2>
              <InputArea>
                <Label>Crachá:</Label>
                <Input
                  name="cracha"
                  type="text"
                  placeholder="Digite o crachá"
                  value={cracha}
                  onChange={(e) => setCracha(e.target.value)}
                />
              </InputArea>
            </Div2>

            <Div2>
              <Label> ou </Label>
            </Div2>

            <Div2>
              <InputArea>
                <Label>Login:</Label>
                <Input
                  name="login"
                  type="text"
                  placeholder="Digite o login"
                  value={login}
                  onChange={(e) => setLogin(e.target.value)}
                />
              </InputArea>
            </Div2>

            <Div2>
              <GreenButton title="Pesquisar" type="button" onClick={handleSearch}>
                Pesquisar
              </GreenButton>
            </Div2>
          </Div>
          {usuarioEncontrado && (
            <Div4>
              <Label>Usuário encontrado:</Label>
              <Div3>

                <Div>
                  <InputArea>
                    <Label>Crachá:</Label>
                    <Input value={usuarioEncontrado.COD_FUNCIONARIO} readOnly />
                  </InputArea>

                  <InputArea>
                    <Label>Login:</Label>
                    <Input value={usuarioEncontrado.LOGON} readOnly />
                  </InputArea>

                  <InputArea>
                    <Label>Nome:</Label>
                    <Input value={usuarioEncontrado.NOME} readOnly />
                  </InputArea>
                </Div>
              </Div3>
              <Label>Preencha:</Label>
              <Div3>
                <Div>
                  <InputArea>
                    <Label>Senha:</Label>
                    <Input name="senha" type="password" value={senha} onChange={(e) => setSenha(e.target.value)} placeholder="Digite sua senha" />
                  </InputArea>

                  <InputArea>
                    <Label>Repetir a senha:</Label>
                    <Input name="repetirSenha" type="password" value={repetirSenha} onChange={(e) => setRepetirSenha(e.target.value)} placeholder="Digite sua senha novamente"
                    />
                  </InputArea>

                  <InputArea>
                    <Label>Email:</Label>
                    <Input
                      name="email"
                      type="text"
                      placeholder="Digite seu e-mail"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />

                  </InputArea>


                </Div>


              </Div3>

              <Div2 style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <GreenButton title="Criar usuário" type="button" onClick={handleSubmitSenhaEmail} style={{ width: '200px', marginTop: '5px' }}>
                  Cadastrar usuário
                </GreenButton>
              </Div2>

            </Div4>
          )}
        </DivGeral>
        <ToastContainer autoClose={2500} position={toast.POSITION.BOTTOM_LEFT} style={{ width: '400px', fontSize: '22px' }} />
      </FormContainer >
      <style jsx global>{`
      .swal2-container.custom-swal-container {
        z-index: 9999; 
      }
    `}</style>
    </>
  );
};

export default Form;


